import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  HostBinding,
  Input,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { PrimeTemplate } from 'primeng/api';
import { Toast, ToastModule } from 'primeng/toast';
import { ToastPosition } from './contract/toast-position.contract';
import { Message } from '../../../contract/message.contract';

@Component({
  selector: 'osp-toast',
  templateUrl: './toast.component.html',
  standalone: true,
  providers: [PrimeTemplate],
  imports: [ToastModule, CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  styleUrl: './toast.component.scss',
})
export class ToastComponent {
  @HostBinding('class') protected hostClass = 'osp-toast';

  @ViewChild(Toast) toast!: Toast;
  @ContentChild(TemplateRef) template!: TemplateRef<unknown>;

  @Input() key?: string;
  @Input() life = 3000;
  @Input() cssClass = '';
  @Input() position: ToastPosition = 'top-right';
  @Input() preventOpenDuplicates = false;
  @Input() preventDuplicates = false;
  @Input() showTransformOptions = 'translateX(100%)';
  @Input() hideTransformOptions = 'translateX(-100%)';
  @Input() showTransitionOptions = '300ms ease-out';
  @Input() hideTransitionOptions = '250ms ease-in';

  get messages(): Message[] | undefined | null {
    return this.toast.messages;
  }

  set messages(messages: Message[] | undefined | null) {
    this.toast.messages = [...(messages ?? [])];
  }
}
